import { useLocation, Link } from "react-router-dom";
import styles from "./Breadcrumb.module.css";
import GlobalIcon from "../GlobalIcon/GlobalIcon";

function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Map route paths to display names
  const routeNames = {
    "": "Welcome",
    "order-book": "Order Book",
    "position-book": "Position Book",
    "holding-book": "Holding Book",
    "order-initiate": "Order Initiate",
    "order-status": "Order Status",
    "funds": "Funds",
    "client-health": "Client Health",
    "settings": "Settings",
    "select-broker": "Connect broker",
  };

  // Build breadcrumb items
  const breadcrumbItems = [];

  // Always start with "Welcome" (home)
  breadcrumbItems.push({
    name: "Welcome",
    path: "/",
    isActive: pathnames.length === 0,
  });

  // Add other path segments
  let currentPath = "";
  pathnames.forEach((pathname, index) => {
    currentPath += `/${pathname}`;
    breadcrumbItems.push({
      name: routeNames[pathname] || pathname,
      path: currentPath,
      isActive: index === pathnames.length - 1,
    });
  });

  return (
    <div className={styles["breadcrumb"]}>
      {breadcrumbItems.map((item) => (
        <div key={item.path} className={styles["breadcrumb-item"]}>
          <span
            className={`${styles["breadcrumb-separator"]} ${
              item.isActive ? styles["separator-active"] : ""
            }`}
          >
            <GlobalIcon iconName="BreadcrumbSeparator" className={styles["separator-icon"]} />
          </span>

          <Link
            to={item.path}
            className={`${styles["breadcrumb-link"]} ${
              item.isActive ? styles["breadcrumb-active"] : ""
            }`}
          >
            {item.name}
          </Link>
        </div>
      ))}
    </div>
  );
}

export default Breadcrumb;
